import { render, staticRenderFns } from "./InterestsOfDecisionMakers.vue?vue&type=template&id=1a55e719&"
import script from "./InterestsOfDecisionMakers.vue?vue&type=script&lang=ts&"
export * from "./InterestsOfDecisionMakers.vue?vue&type=script&lang=ts&"
import style0 from "./InterestsOfDecisionMakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports